<template>

  <modalo
    :title="disqualifyReason.name"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => disqualifyReason">

    <form id="disqualify-reason-form" v-on:submit.prevent="saveDisqualifyReason(disqualifyReason)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input v-autofocus type="text" class="form-control" v-model="disqualifyReason.name">
        <ValidateMessage :error="validateErrors.name" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="disqualify-reason-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <!--<button
            type="button"
            class="btn btn-danger"
            @click="deleteDisqualifyReason(disqualifyReason._id)">{{ $t('Delete') }}</button>-->
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'DisqualifyReasonForm',
  components: {
  },
  props: [
    'initDisqualifyReason'
  ],
  data () {
    return {
      loading: false,
      disqualifyReason: this.defaultValues(this.initDisqualifyReason),
      validateErrors: {}
    }
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
      }, values)
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveDisqualifyReason
    */
    saveDisqualifyReason (data) {
      if (data._id) this.updateDisqualifyReason(data._id, data)
      else this.createDisqualifyReason(data)
    },
    /*
    createDisqualifyReason
    */
    createDisqualifyReason (data) {
      this.loading = true

      this.$store
      .dispatch('createDisqualifyReason', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateDisqualifyReason
    */
    updateDisqualifyReason (id, data) {
      this.loading = true

      this.$store
      .dispatch('updateDisqualifyReason', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteDisqualifyReason (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteDisqualifyReason', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DisqualifyReason/DisqualifyReasonForm.vue